import React from 'react';
import LoadingSpinner from './ergo-elements/components/LoadingSpinner';
import Notification from './Notification';

export const NotificationsContext = React.createContext('light');

const timeoutInMiliseconds = 200000;

class NotificationsProvider extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      notifications: [],
      loading: false
    };
  }

  dismissNotification = () =>
    this.setState((s, p) => ({ notifications: s.notifications.slice(0, -1) }));

  setLoading = val => {
    this.setState({ loading: val });
    if (val) {
      setTimeout(() => {
        if (this.state.loading) {
          this.setLoading(false);
          this.pushNotification({ type: 'Timeout', timeoutInMiliseconds });
        }
      }, timeoutInMiliseconds);
    }
  };

  pushNotification = notification => {
    this.setState((s, p) => ({
      notifications: [...s.notifications, notification]
    }));
  };

  render() {
    return (
      <NotificationsContext.Provider
        value={{
          setLoading: this.setLoading,
          pushNotification: this.pushNotification
        }}
      >
        {this.state.loading ? <LoadingSpinner show={true} /> : null}
        {this.props.children}
        {this.state.notifications.map((n, i) => (
          <Notification
            error={n}
            key={i}
            open
            dismiss={this.dismissNotification}
          />
        ))}
      </NotificationsContext.Provider>
    );
  }
}

export default NotificationsProvider;
